import { VisualContainer, ClientVisualImage, AgencyVisualImage } from "./styles/Visual.styled";

export const ClientVisual = ({ name, visual }) => {
  return (
    <VisualContainer>
      {visual && <ClientVisualImage src={visual} alt={`Logo ${name}`} />}
      <span>{name}</span>
    </VisualContainer>
  );
};

export const AgencyVisual = ({ name, visual }) => {
  return (
    <VisualContainer>
      {visual && <AgencyVisualImage src={visual} alt={`Logo ${name}`} />}
      <span>{name}</span>
    </VisualContainer>
  );
};
